import { Component, OnInit } from '@angular/core';
import 'rxjs/Rx';

import { ApplyNow } from './apply-now';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-component-apply-now',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  // private url = 'http://localhost:8080/vacancies/submit';
  private url = 'https://api.newlinesr.com/vacancies/submit';
  private headers = '?X-Authorization=126d39f51313d66e5e86daccd19fb1c91bdc33c940cc16b62cfc8cc3dd6c8334&Application=newlinesr';
  private applyNow = new ApplyNow();
  private submitted = false;
  private errors = false;

  public uploader: FileUploader = new FileUploader(
    {
      url: this.url + this.headers
    }
  );

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {

    this.route.queryParams.subscribe((params: Params) => {
      this.applyNow.jobid = params['jobId'];
    });
    this.applyNow.jobid = this.route.snapshot.queryParams['jobId'];
    this.uploader.onBeforeUploadItem = () => {
      this.uploader.options.additionalParameter = {
        jobid: this.applyNow.jobid,
        name: this.applyNow.name,
        phone: this.applyNow.phone,
        email: this.applyNow.email,
        gdpr: this.applyNow.gdpr === 1
      };
      this.submitted = true;
    };
    this.uploader.onErrorItem = function (fileItem: FileItem, response: {}, status: number) {
      this.errors = true;
      console.error(response, status);
    };
  }

  onSubmit(form) {
    if (form.form.valid && this.uploader.queue.length > 0) {
      this.uploader.uploadAll();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts